import type { Link } from '@webapp/common/entities/link';

export interface LinkResponse {
    NAME: string;
    ID: number;
    TITLE: string;
    HIDDEN: boolean;
    DISALLOW_REFILLING: boolean;
    PARAMS: string | null;
}

interface ValueResponse {
    ID: number;
    PARAM_ID: number;
    VALUE: string;
}

export const mapLink = ({ HIDDEN, ID, NAME, TITLE, DISALLOW_REFILLING, PARAMS }: LinkResponse): Link => ({
    id: ID,
    name: TITLE,
    code: NAME,
    showInStats: !HIDDEN,
    disallowRefilling: DISALLOW_REFILLING,
    editing: false,
    values: [],
    params: PARAMS ? JSON.parse(PARAMS) : {},
});

export const mapValue = ({ VALUE }: ValueResponse) => VALUE;
